<div class="flip-text-container gap-x" style="--gap: {{ncGap}}px;">
    <ng-container *ngFor="let char of characters; let i = index">
        <span [@flipState]="{value: char.state, params: {duration: ncDuration, delay: char.delay}}"
            class="origin-center drop-shadow-sm flip-span" [innerHTML]="char.char === ' ' ? '&nbsp;' : char.char"></span>
    </ng-container>
</div>